import React, { useEffect, useState, useRef } from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {Carousel, Image, Button, Row, Col, List, notification, Modal, Input, message} from 'antd';
import {ArrowLeftOutlined, DownloadOutlined, LockOutlined} from '@ant-design/icons'
import success from '../../images/document/success.png'
import failed from '../../images/document/failed.png'
import {cpy} from "../../utils/cmn";
import {Post, URL} from "../../server/http";
import { fileList, fileMap } from './enum'
import gz from "../../images/foot/gz.png";
import './index.less'
import logo from "../../images/logo3.png";

const initData = {nickname: '', phone: '', company: '', content: ''}

function Result() {
    const navigate = useNavigate();
    const { id } = useParams();
    const tempId = id.split('-')[0]
    const code = id.split('-')[1]

    // componentDidMount componentWillUnmount
    useEffect(() => {
        if (code+'' === '1' && tempId) {
            downloadFile(fileList[Number(tempId) - 1])
        }

        return () => {}
    }, []);

    //
    const downloadFile = (item) => {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = fileMap[item['key']]
        a.download = item['name']
        document.body.appendChild(a);
        a.click()
        document.body.removeChild(a);
    }

    //
    return (
        <div className={'full-page'}>
            <Row type={'flex'} justify={'space-between'} align={'middle'} style={{padding: '8vw 4vw 1vw'}}>
                <ArrowLeftOutlined style={{fontSize: '5vw'}} onClick={()=>{navigate('/consult/'+tempId)}}/>
            </Row>
            {
                code+''==='1'?(
                    <>
                        <Row type={'flex'} justify={'center'} style={{marginTop: '12vw'}}>
                            <img src={success} alt="" style={{width: '40vw'}}/>
                        </Row>
                        <Row type={'flex'} justify={'center'} className={'doc-title'} style={{marginTop: '2vw'}}>
                            提交成功
                        </Row>
                        <Row type={'flex'} justify={'center'} className={'doc-mini-title'} style={{marginTop: '2vw'}}>
                            感谢关注，资料已下载至手机
                        </Row>
                    </>
                ):(
                    <>
                        <Row type={'flex'} justify={'center'} style={{marginTop: '12vw'}}>
                            <img src={failed} alt="" style={{width: '40vw'}}/>
                        </Row>
                        <Row type={'flex'} justify={'center'} className={'doc-title'} style={{marginTop: '2vw'}}>
                            提交失败
                        </Row>
                        <Row type={'flex'} justify={'center'} className={'doc-mini-title'} style={{marginTop: '2vw'}}>
                            请检查您的邮箱/手机号是否正确
                        </Row>
                    </>
                ) 
            }
            <Row type={'flex'} justify={'center'} style={{marginTop: '20vw'}}>
                <img src={gz} alt="" style={{width: '30vw'}}/>
            </Row>
            <Row type={'flex'} justify={'center'} style={{marginTop: '2vw', fontSize: '3.6vw'}}>
                扫码关注
            </Row>
            <Row type={'flex'} justify={'center'} style={{marginTop: '1vw', fontSize: '3.6vw'}}>
                了解更多信息
            </Row>
            <Row type={'flex'} justify={'center'} style={{marginTop: '16vw'}}>
                <img src={logo} alt="" style={{width: '48vw'}}/>
            </Row>
        </div>
    );
}

export default Result;
